import { Loader2 } from "lucide-react";

export const STATUSES = ["New", "Contacted", "Quoted", "Won"];

const STYLES = {
  New: "bg-amber-100 text-amber-900 border-amber-300",
  Contacted: "bg-sky-100 text-sky-900 border-sky-300",
  Quoted: "bg-violet-100 text-violet-900 border-violet-300",
  Won: "bg-emerald-100 text-emerald-900 border-emerald-300",
};

export const statusClass = (s) => STYLES[s] || STYLES.New;

export default function StatusSelect({ lead, index, saving, onChange }) {
  return (
    <span className="relative inline-flex items-center">
      <select
        data-testid={`admin-lead-status-${index}`}
        value={lead.status || "New"}
        disabled={saving}
        onChange={(e) => onChange(lead.id, e.target.value)}
        className={`appearance-none rounded-full border pl-3 pr-7 py-1 text-xs font-semibold cursor-pointer transition-colors duration-300 disabled:opacity-60 ${statusClass(lead.status)}`}
      >
        {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <span className="pointer-events-none absolute right-2.5 text-[10px] opacity-70">
        {saving ? <Loader2 size={11} className="animate-spin" /> : "▾"}
      </span>
    </span>
  );
}
